import { PauseCover } from "aic";
import { IRequestStatus } from "functions/api/interface";
import { NotificationViewDto } from "functions/api/notifications/getUserNotifications";
import { Dispatch, SetStateAction } from "react";
import { Col, Container, Offcanvas, Row } from "react-bootstrap";
import { NotificationsList } from "./NotificationsList";
import { NotificationsReadButton } from "./NotificationsReadButton";

interface NotificationsPanelProps {
  notificationsList: NotificationViewDto[];
  setNotificationsList: Dispatch<SetStateAction<NotificationViewDto[]>>;
  showNotifications: boolean;
  setShowNotifications: Dispatch<SetStateAction<boolean>>;
  loadNotificationsRequest: IRequestStatus<string>;
}

/**
 * Off-canvas panel showing the user's notifications and controls to mark them read.
 *
 * @param props - Destructured parameter object
 * @param props.notificationsList - Array of notifications to display
 * @param props.setNotificationsList - Callback to update the notifications list
 * @param props.showNotifications - Whether the panel is visible
 * @param props.setShowNotifications - Callback to toggle panel visibility
 * @param props.loadNotificationsRequest - Request status for loading notifications
 */
export const NotificationsPanel = ({
  notificationsList,
  setNotificationsList,
  showNotifications,
  setShowNotifications,
  loadNotificationsRequest,
}: NotificationsPanelProps): React.ReactElement => (
  <Offcanvas
    show={showNotifications}
    placement="end"
    onHide={() => {
      setShowNotifications(false);
    }}
    backdrop={false}
    scroll={true}
  >
    <Offcanvas.Header
      closeButton
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <Offcanvas.Title>Notifications</Offcanvas.Title>
    </Offcanvas.Header>
    <Offcanvas.Body>
      <Container>
        {loadNotificationsRequest.requesting && <PauseCover text={"Fetching Notifications..."} />}
        {loadNotificationsRequest.error ? (
          <> Something went wrong when fetching your notifications... </>
        ) : notificationsList.length > 0 ? (
          <>
            <Row>
              <Col xs={{ span: "auto" }}>
                <NotificationsReadButton
                  notificationsList={notificationsList}
                  setNotificationsList={setNotificationsList}
                />
              </Col>
            </Row>
            <Row className="mt-4">
              <Col>
                <NotificationsList
                  notificationsList={notificationsList}
                  setNotificationsList={setNotificationsList}
                  showNotifications={showNotifications}
                  setShowNotifications={setShowNotifications}
                />
              </Col>
            </Row>
          </>
        ) : (
          <>No Notifications Yet...!</>
        )}
      </Container>
    </Offcanvas.Body>
  </Offcanvas>
);

NotificationsPanel.displayName = "NotificationsPanel";
